<script>
    import _ from 'lodash'
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import EventBus from '@/components/EventBus'

    import OrgService from '@/request/user/org'
    import OperationService from '@/request/aims/operation'
    import PermissionUtils from '@/utils/permission'

    export default {
        computed: {
            ...mapGetters('operation', {
                options: 'options'
            })
        },
        components: {},
        data () {
            return {
                tableCellStyle: {
                    padding: 0
                },
                hospitals: [],
                chid: null,
                oids: [],
                operationLoading: false,
                operations: [],
                currentOperation: {},
                visibleRecordImage: false,
                visibleEditOperation: false,
                editOperation: {}
            }
        },
        created: function () {
            this.chid = this.options.hid || null
            this.listHospital()
            EventBus.$on('websocket-message', this.handleWebsocket)
        },
        mounted: function () {},
        beforeDestroy: function () {
            EventBus.$off('websocket-message', this.handleWebsocket)
        },
        watch: {
            'chid': function () {
                this.listOids()
            },
            'oids': function () {
                this.listOperation()
            }
        },
        methods: {
            hasPermission (sns) {
                return PermissionUtils.hasPermission(sns, this.$store.getters.permissions, false)
            },
            listHospital () {
                OrgService.listOrg({
                    parents: 1,
                    typeSns: 'lx0001001'
                }).then(res => {
                    this.hospitals = _.cloneDeep(res.result || [])
                    if (!_.isEmpty(this.hospitals) && !this.chid) {
                        this.chid = this.hospitals[0].id
                    } else if (this.chid) {
                        this.listOids()
                    }
                })
            },
            listOids () {
                let self = this
                if (!self.chid) {
                    self.oids = []
                    return
                }
                OrgService.listOrgId({
                    pids: self.chid,
                    descendant: 1
                }).then(res => {
                    self.oids = res.result || []
                })
            },
            listOperation () {
                let self = this
                self.operations = []
                if (_.isEmpty(self.oids)) {
                    return
                }
                self.operationLoading = true
                let poperation = OperationService.list({
                    // start: self.currentDate,
                    // end: moment(self.currentDate).endOf('day').valueOf(),
                    orgs: _.join(self.oids),
                    status: '2'
                })
                poperation.then(res => {
                    let data = res.result || []
                    self.operations = _.sortBy(data, ['startTime', 'roomName'])
                })
                poperation.finally(() => {
                    self.operationLoading = false
                })
            },
            handleWebsocket (data) {
                if (!data) {
                    return
                }
                if (_.isString(data)) {
                    data = JSON.parse(data)
                }
                if (!data.source || data.source !== 'eber-system-aims') {
                    return
                }
                if (_.isEmpty(this.oids)) {
                    return
                }
                let operation = data.message
                let oid = operation.oid
                if (_.indexOf(this.oids, oid) < 0) {
                    return
                }
                this.listOperation()
            },
            handleCloseEditOperation () {
                this.visibleEditOperation = false
                this.editOperation = {}
            },
            editOperationSuccess (operation) {
                console.log(operation)
                OperationService.approve({
                    id: operation.id,
                    result: 1,
                    mess: null
                }).then(() => {
                    this.listOperation()
                })
                this.visibleEditOperation = false
            },
            approveOperation (operation) {
                if (_.isEmpty(operation)) {
                    this.$message.error('获取手术信息失败，请刷新页面重试')
                    return
                }
                if (!this.hasPermission('per_opration_001002')) {
                    this.$message.error('您没有审批权限')
                    return
                }
                this.editOperation = _.cloneDeep(operation)
                this.visibleEditOperation = true
            },
            reject (operation) {
                if (_.isEmpty(operation)) {
                    this.$message.error('获取手术信息失败，请刷新页面重试')
                    return
                }
                this.$prompt('请输入拒绝理由', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S+/,
                    inputErrorMessage: '拒绝理由不能为空',
                    inputPlaceholder: '请输入拒绝理由'
                }).then(({ value }) => {
                    OperationService.approve({
                        id: operation.id,
                        result: 0,
                        mess: value
                    }).then(res => {
                        if (res.result) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            })
                        }
                        this.listOperation()
                        this.visibleEditOperation = false
                    })
                }).catch(() => {
                })
            },
            /*approveOperation (operation) {
                if (!operation) {
                    return
                }
                if (!this.hasPermission('per_opration_001002')) {
                    this.$message.error('您没有审批权限')
                    return
                }
                this.$confirm('是否同意患者[' + operation.patName + ']的手术申请？', '审批', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '同意',
                    cancelButtonText: '拒绝'
                }).then(() => {
                    OperationService.approve({
                        id: operation.id,
                        result: 1,
                        mess: null
                    }).then(() => {
                        this.listOperation()
                    })
                }).catch(action => {
                    if (action !== 'cancel') {
                        return
                    }
                    this.$prompt('请输入拒绝理由', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /\S+/,
                        inputErrorMessage: '拒绝理由不能为空',
                        inputPlaceholder: '请输入拒绝理由'
                    }).then(({ value }) => {
                        OperationService.approve({
                            id: operation.id,
                            result: 0,
                            mess: value
                        }).then(res => {
                            if (res.result) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                })
                            }
                            this.listOperation()
                        })
                    }).catch(() => {
                        this.approveOperation(operation)
                    })
                })
            },*/
            tableTimeFormatter (row, column, cellValue) {
                if (!cellValue) {
                    return ''
                }
                return moment(cellValue).format('MM-DD HH:mm')
            },
            showRecordImages (operation) {
                if (!operation) {
                    return
                }
                this.currentOperation = _.cloneDeep(operation)
                this.visibleRecordImage = true
            }
        },
        filters: {}
    }
</script>

<template>
    <el-container>
        <el-header height="45px">
            <el-form :inline="true" class="demo-form-inline" size="small">
                <el-form-item>
                    <el-select v-model="chid" placeholder="请选择医院" :disabled="hospitals.length <= 1">
                        <el-option
                                v-for="item in hospitals"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="$router.push({name: 'operation_arrange'})">返 回</el-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="p20-scrollbar__view">
                <el-table
                        v-loading="operationLoading"
                        :data="operations"
                        border
                        stripe
                        size="mini"
                        highlight-current-row
                        :cell-style="tableCellStyle"
                        :header-cell-style="tableCellStyle"
                        style="width: 100%">
                    <el-table-column prop="startTime" label="时间" width="100" :formatter="tableTimeFormatter"></el-table-column>
                    <el-table-column prop="historySn" label="病历号" width="70"></el-table-column>
                    <el-table-column prop="bedid" label="床号" width="60"></el-table-column>
                    <el-table-column prop="patName" label="姓名" width="60"></el-table-column>
                    <el-table-column prop="sex" label="性别" width="40">
                        <template slot-scope="scope">
                            {{ !!scope.row.sex && scope.row.sex % 2 === 0 ? '女' : '男' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="age" label="年龄" width="40"></el-table-column>
                    <el-table-column prop="diagnoseNames" label="诊断+术式">
                        <template slot-scope="scope">
                            <span>{{scope.row.diagnoseNames}};{{scope.row.operatingNames}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="device" label="设备准备" width="120"></el-table-column>
                    <el-table-column prop="specialPrepare" label="器械准备"></el-table-column>
                    <el-table-column prop="roomName" label="手术间" width="57" align="center"></el-table-column>
                    <el-table-column prop="operatorName" label="主刀" width="60"></el-table-column>
                    <el-table-column prop="assistantFirstName" label="一助" width="60"></el-table-column>
                    <el-table-column prop="washNurseName" label="洗手" width="60"></el-table-column>
                    <el-table-column prop="tourNurseName" label="巡回" width="60"></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button size="small" type="text" @click="showRecordImages(scope.row)">查看图片</el-button>
                            <el-button size="small" type="text" @click="approveOperation(scope.row)" v-if="hasPermission('per_opration_001002')">审批</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
        </el-main>
        <!-- 查看图片 -->
        <el-dialog title="图片" :visible.sync="visibleRecordImage">
            <record-record-image-list v-if="currentOperation.drid" :record="currentOperation" :enableAdd="false"></record-record-image-list>
            <div v-else>没有关联病历</div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="visibleRecordImage = false">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 编辑手术 -->
        <el-dialog title="编辑手术" :visible.sync="visibleEditOperation" @close="handleCloseEditOperation" top="0" width="1000px">
            <aims-operation-edit
                    ref="operationEditRef"
                    v-model="editOperation"
                    :show-buttons="false"
                    @cancle="visibleEditOperation = false"
                    @saveDone="editOperationSuccess"
            ></aims-operation-edit>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="$refs['operationEditRef'].submit()">同 意</el-button>
                <el-button type="warning" @click="reject(editOperation)">拒 绝</el-button>
                <el-button @click="visibleEditOperation = false">取 消</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
